/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamQuestionQuestionId } from './oralExamQuestionQuestionId';
import type { AnswerKeyPoint } from './answerKeyPoint';
import type { OralExamQuestionFills } from './oralExamQuestionFills';
import type { OralExamQuestionFillKind } from './oralExamQuestionFillKind';
import type { OralExamQuestionConcept } from './oralExamQuestionConcept';
import type { OralExamQuestionBloom } from './oralExamQuestionBloom';
import type { OralExamQuestionEstTimeSec } from './oralExamQuestionEstTimeSec';

/**
 * Oral exam question in the task pool (API view).

question_id is None for newly-added questions (the server assigns a uuid4 on save).
Input rejects empty/whitespace-only ``question``. ``from_db`` stays load-tolerant
for legacy stored blanks (DB model remains permissive).
 */
export interface OralExamQuestion {
  questionId?: OralExamQuestionQuestionId;
  question: string;
  referringTaskIds?: string[];
  referringResourceIds?: string[];
  answerKey?: AnswerKeyPoint[];
  fills?: OralExamQuestionFills;
  fillKind?: OralExamQuestionFillKind;
  concept?: OralExamQuestionConcept;
  bloom?: OralExamQuestionBloom;
  estTimeSec?: OralExamQuestionEstTimeSec;
}
